import { render, staticRenderFns } from "./DataRecordExploreHeader.vue?vue&type=template&id=4072e3d8&scoped=true&"
import script from "./DataRecordExploreHeader.vue?vue&type=script&lang=js&"
export * from "./DataRecordExploreHeader.vue?vue&type=script&lang=js&"
import style0 from "./DataRecordExploreHeader.vue?vue&type=style&index=0&id=4072e3d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072e3d8",
  null
  
)

export default component.exports